var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import compose from 'recompose/compose';
import { injectIntl } from 'react-intl';
import Input from '../../components/Input';
import Select from '../../components/Select';
import WithValidation from '../../lib/WithValidation';
import require from '../../lib/WithValidation/rules/required';
import email from '../../lib/WithValidation/rules/email';
import password from '../../lib/WithValidation/rules/password';
import match from '../../lib/WithValidation/rules/match';
import hasMinLength from '../../lib/WithValidation/rules/hasMinLength';
import phone from '../../lib/WithValidation/rules/phone';
import Icon from '../../components/Icon';
import PropTypes from 'prop-types';
import translate from '../../lib/utils/translate';

var UserInfo = function (_Component) {
  _inherits(UserInfo, _Component);

  function UserInfo(props) {
    _classCallCheck(this, UserInfo);

    var _this = _possibleConstructorReturn(this, (UserInfo.__proto__ || Object.getPrototypeOf(UserInfo)).call(this, props));

    _this._handleBlur = function (field, value) {
      var onBlur = _this.props.onBlur;


      onBlur(field, value);
      _this.setState(_defineProperty({}, field, value));
    };

    _this.state = {
      Email: props.Email,
      UserName: props.UserName,
      Password: props.Password,
      MobilePhoneNumber: props.MobilePhoneNumber,
      showPromoField: false
    };
    return _this;
  }

  _createClass(UserInfo, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          errors = _props.errors,
          onSubmit = _props.onSubmit,
          intl = _props.intl,
          _onBlur = _props.onBlur,
          countries = _props.countries,
          ipCountry = _props.ipCountry,
          _onChange = _props.onChange,
          showLabel = _props.showLabel,
          showPlaceholder = _props.showPlaceholder;
      var _state = this.state,
          Email = _state.Email,
          UserName = _state.UserName,
          Password = _state.Password,
          MobilePhoneNumber = _state.MobilePhoneNumber,
          showPromoField = _state.showPromoField;


      var handleTogglePromo = function handleTogglePromo() {
        _this2.setState(function (prevState) {
          return {
            showPromoField: !prevState.showPromoField
          };
        });
      };

      var handleClosePromo = function handleClosePromo() {
        _this2.setState(function () {
          return { showPromoField: false };
        });
      };

      return React.createElement(
        'form',
        { className: 'Step1 form signup-form', onSubmit: onSubmit },
        React.createElement(Input, {
          className: 'layout-item-full-width',
          placeholder: showPlaceholder && translate({ id: 'label.choose_username' }, intl),
          title: showLabel && translate({ id: 'label.choose_username' }, intl),
          name: 'UserName',
          value: UserName,
          onBlur: function onBlur(value) {
            return _this2._handleBlur('UserName', value);
          },
          error: errors.UserName && translate({ id: errors.UserName }, intl)
        }),
        React.createElement(Input, {
          className: 'layout-item-full-width',
          placeholder: showPlaceholder && translate({ id: 'label.email' }, intl),
          title: showLabel && translate({ id: 'label.email' }, intl),
          type: 'email',
          name: 'Email',
          value: Email,
          onBlur: function onBlur(value) {
            return _this2._handleBlur('Email', value);
          },
          error: errors.Email && translate({ id: errors.Email }, intl)
        }),
        React.createElement(
          'div',
          { className: 'layout-item' },
          React.createElement(Select, {
            className: 'layout-item-3',
            title: '',
            options: countries && countries.value.map(function (i) {
              return {
                value: i.callingCode,
                label: '+' + i.callingCode
              };
            }),
            name: 'CallingCode',
            onBlur: function onBlur(value) {
              return _onBlur('CallingCode', value);
            },
            onChange: function onChange(event) {
              var value = event;

              if (event.currentTarget) value = event.currentTarget.value;

              return _onChange('CallingCode', value);
            },
            defaultValue: ipCountry ? ipCountry.callingCode : null
          }),
          React.createElement(Input, {
            className: 'layout-item-9',
            placeholder: showPlaceholder && translate({ id: 'label.mobile_number' }, intl),
            title: showLabel && translate({ id: 'label.mobile_number' }, intl),
            name: 'MobilePhoneNumber',
            type: 'tel',
            value: MobilePhoneNumber,
            onBlur: function onBlur(value) {
              return _onBlur('MobilePhoneNumber', value);
            },
            error: errors.MobilePhoneNumber && translate({ id: errors.MobilePhoneNumber }, intl)
          })
        ),
        React.createElement(Input, {
          className: 'layout-item-full-width',
          placeholder: showPlaceholder && translate({ id: 'label.choose_password' }, intl),
          title: showLabel && translate({ id: 'label.choose_password' }, intl),
          type: 'password',
          name: 'Password',
          value: Password,
          onBlur: function onBlur(value) {
            return _this2._handleBlur('Password', value);
          },
          error: errors.Password && translate({ id: errors.Password }, intl)
        }),
        React.createElement(Input, {
          className: 'layout-item-full-width',
          placeholder: showPlaceholder && translate({ id: 'label.confirm_password' }, intl),
          title: showLabel && translate({ id: 'label.confirm_password' }, intl),
          type: 'password',
          name: 'confirm_password',
          onBlur: function onBlur(value) {
            return _this2._handleBlur('confirm_password', value);
          },
          error: errors.confirm_password && translate({ id: errors.confirm_password }, intl)
        }),
        showPromoField && React.createElement(
          'div',
          { className: 'layout-item promo' },
          React.createElement(Input, {
            placeholder: showPlaceholder && translate({ id: 'label.bonus_code' }, intl),
            title: showLabel && translate({ id: 'label.bonus_code' }, intl),
            name: 'PromoCode'
          }),
          React.createElement(
            'a',
            { className: 'promo-close' },
            React.createElement(Icon, {
              onClick: handleClosePromo,
              className: 'promo-close',
              icon: 'times'
            })
          )
        ),
        !showPromoField && React.createElement(
          'div',
          { className: 'layout-item-full-width promo-button' },
          React.createElement(
            'a',
            { className: 'button tertiary wide', onClick: handleTogglePromo },
            translate({ id: 'action.button.promo_code' }, intl)
          )
        ),
        React.createElement('div', { className: 'divider' }),
        React.createElement(
          'div',
          { className: 'layout-item-full-width' },
          React.createElement(
            'button',
            { className: 'button primary wide', type: 'submit' },
            translate({ id: 'action.button.continue' }, intl)
          )
        )
      );
    }
  }]);

  return UserInfo;
}(Component);

UserInfo.propTypes = {
  /** The name of the field */
  name: PropTypes.string,
  /** The current value */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number, PropTypes.object]),
  /** The blur handler that will receive the updated value as it's only param */
  onBlur: PropTypes.func,
  /** The on change handler listens for changes updates value */
  onChange: PropTypes.func,
  /** The error handler that in case of error receives the error value */
  error: PropTypes.object,
  /** The submit button */
  onSubmit: PropTypes.func,
  /** Mark the field as required and display an asterisk next to the label */
  required: PropTypes.bool
};
UserInfo.defaultProps = {
  name: '',
  value: '',
  onBlur: null,
  onChange: null,
  error: {},
  onSubmit: null,
  required: true
};


var rules = {
  Email: [[require, 'error.empty.email'], [email, 'error.condition.email']],
  UserName: [[require, 'error.empty.username']],
  MobilePhoneNumber: [[require, 'error.empty.phone'], [phone, 'error.condition.phone']],
  CallingCode: [[require, 'error.empty.callcode']],
  Password: [[require, 'error.empty.password'], [hasMinLength(8), 'error.condition.password'], [password, 'error.condition.password']],
  confirm_password: [[match('Password'), 'error.match.password']],
  PromoCode: []
};

export default compose(WithValidation(rules), injectIntl)(UserInfo);